import "./sidebar.scss";
import React, { useEffect, useState } from "react";
import {
  ExpandLess,
  ExpandMore,
} from "@mui/icons-material";
import DashboardIcon from "@mui/icons-material/Dashboard";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import ChecklistRtlIcon from "@mui/icons-material/ChecklistRtl";
import PreviewIcon from "@mui/icons-material/Preview";
import PlaylistRemoveIcon from "@mui/icons-material/PlaylistRemove";
import StoreIcon from "@mui/icons-material/Store";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import ScatterPlotIcon from '@mui/icons-material/ScatterPlot';
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import AssessmentIcon from '@mui/icons-material/Assessment';
// import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../../PrivateRoute";
import logo from "../../images/logo.png";
import { getPendingCounts } from "../../DataCenter/apiService";
import Badge from "@mui/material/Badge";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import NotificationBell from "../../Common/NotificationBell";


const Sidebar = ({ isSuccess }) => {
  const navigate = useNavigate();
  const { userId, empId } = useAuth();
  const location = useLocation();
  const [pendingCount, setPendingCount] = useState({});
  const [openMenu, setOpenMenu] = useState({
    sanction: false,
    inprogress: false,
    final: false,
    rejection: false,
    dashboard: false,
  });


useEffect(() => {
  const path = location.pathname;

  setOpenMenu({
    sanction:
      path.startsWith("/beneficiary") ||
      path === "/training",

    inprogress:
      path.startsWith("/inprogress") ||
      path.startsWith("/training-in-progress"),

    final:
      path.startsWith("/finalpreview") ||
      path.startsWith("/training-final-preview"),

    rejection:
      path.startsWith("/rejectedList") ||
      path.startsWith("/training-rejected"),

    dashboard:
      path.startsWith("/dashboard-list") ||
      path.startsWith("/dashboard/training-records"),
  });
}, [location.pathname]);

  useEffect(() => {
    async function fetchCounts() {
      const data = await getPendingCounts(userId);
      setPendingCount(data || {});
    }
    fetchCounts();
  }, [isSuccess, userId]);

  const handleLogout = () => {
    localStorage.removeItem("jwtToken");
    navigate("/");
  };

  const toggleMenu = (key) => {
    setOpenMenu((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const renderSubLink = (to, icon, text) => (
    <li style={{ padding: "3px 6px" }}>
      <NavLink
        to={to}
        style={({ isActive }) => ({
          textDecoration: "none",
          backgroundColor: isActive ? "rgba(255, 255, 255, 0.25)" : "transparent",
          borderRadius: " 8px 0px 0px 8px ",
          padding: "8px 6px",
          width: "100%",
          display: "flex",
          alignItems: "center",
        })}
        className={({ isActive }) => isActive ? "active-link" : ""}
      >
        {icon}
        <span style={{ marginLeft: "8px" }}>{text}</span>
      </NavLink>
    </li>
  );

  return (
    <div className="sidebar">
      <div className="top">
        <NavLink to="/" style={{ textDecoration: "none" }}>
          <span>
            <img src={logo} alt="Logo" className="logo" />
          </span>
        </NavLink>
        <NotificationBell empId={empId} />
      </div>
      <hr />
      <div className="center">
        <ul>

          <li className="menu-header" onClick={() => toggleMenu("sanction")}>
            <div className="menu-title">
              <PersonOutlineIcon className="icon" />
              <span>Sanction</span>
            </div>
            {openMenu.sanction ? <ExpandLess /> : <ExpandMore />}

          </li>
          {openMenu.sanction && (
            <ul className="submenu">
              {renderSubLink("/beneficiary", <FiberManualRecordIcon style={{ fontSize: '8px' }}  className="icon" />, "Beneficiary Records")}
              {renderSubLink("/training", <FiberManualRecordIcon style={{ fontSize: '8px' }}  className="icon" />, "Training/Other Exp Records")}
            </ul>
          )}

          <li className="menu-header" onClick={() => toggleMenu("inprogress")}>
            <div className="menu-title">
              <ChecklistRtlIcon className="icon" />
              <Badge
                badgeContent={pendingCount.approvalCount}
                color="success"
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
                sx={{
                  "& .MuiBadge-badge": {
                    color: "white ! important",
                    fontSize: "0.7rem",
                    height: "16px",
                    minWidth: "16px",
                  },
                }}
              >
                In-Progress
              </Badge>  </div>
            {openMenu.inprogress ? <ExpandLess /> : <ExpandMore />}

          </li>
          {openMenu.inprogress && (
            <ul className="submenu">
              {renderSubLink("/inprogress", <FiberManualRecordIcon style={{ fontSize: '8px' }} className="icon" />, "Beneficiary Records")}
              {renderSubLink("/training-in-progress", <FiberManualRecordIcon style={{ fontSize: '8px' }} className="icon" />, "Training/Other Exp Records")}
            </ul>
          )}

          <li className="menu-header" onClick={() => toggleMenu("final")}>
            <div className="menu-title">
              <PreviewIcon className="icon" />
              <span>Final Preview</span>

            </div>
            {openMenu.final ? <ExpandLess /> : <ExpandMore />}


          </li>
          {openMenu.final && (
            <ul className="submenu">
              {renderSubLink("/finalpreview", <FiberManualRecordIcon style={{ fontSize: '8px' }} className="icon" />, "Beneficiary Records")}
              {renderSubLink("/training-final-preview", <FiberManualRecordIcon style={{ fontSize: '8px' }} className="icon" />, "Training/Other Exp Records")}
            </ul>
          )}

          <li className="menu-header" onClick={() => toggleMenu("rejection")}>
            <div className="menu-title">
              <PlaylistRemoveIcon className="icon" />
              <Badge
                badgeContent={pendingCount.rejectionCount}
                color="error"
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
                sx={{
                  "& .MuiBadge-badge": {
                    color: "white ! important",
                    fontSize: "0.7rem",
                    height: "16px",
                    minWidth: "16px",
                  },
                }}
              >
                Rejection Center
              </Badge> </div>
            {openMenu.rejection ? <ExpandLess /> : <ExpandMore />}

          </li>
          {openMenu.rejection && (
            <ul className="submenu">
              {renderSubLink("/rejectedList", <FiberManualRecordIcon style={{ fontSize: '8px' }} className="icon" />, "Beneficiary Records")}
              {renderSubLink("/training-rejected", <FiberManualRecordIcon style={{ fontSize: '8px' }} className="icon" />, "Training/Other Exp Records")}
            </ul>
          )}

          <li className="menu-header" onClick={() => toggleMenu("dashboard")}>
            <div className="menu-title">
              <DashboardIcon className="icon" />
              <span>Dashboard</span>
            </div>
            {openMenu.dashboard ? <ExpandLess /> : <ExpandMore />}
          </li>
          {openMenu.dashboard && (
            <ul className="submenu">
              {renderSubLink("/dashboard-list", <FiberManualRecordIcon style={{ fontSize: '8px' }} className="icon" />, "Beneficiary Records")}
              {renderSubLink("/dashboard/training-records", <FiberManualRecordIcon style={{ fontSize: '8px' }} className="icon" />, "Training/Other Exp Records")}
            </ul>
          )}

          {renderSubLink("/report-list", <AssessmentIcon className="icon" />, "Report Tab")}

<li>
            <NavLink
              to="/resolution"
              style={({ isActive }) => ({
                textDecoration: "none",
                // backgroundColor: isActive ? '#dcdcdc' : 'transparent',
                backgroundColor: isActive ? '#ece8ff' : 'transparent',
                borderRadius: "10px 0px 0px 10px ",
                padding: "10px 4px",
                width: "100%",
                margin: isActive ? 'margin: 5px 0px 5px 5px' : "0px",
                pointerEvents: "none",
                opacity: 0.5,
              })}
            >
              <CloudUploadIcon className="icon" />
              <span>Resolution Upload</span>
            </NavLink>
          </li>

          {renderSubLink("/myprofile", <AccountCircleOutlinedIcon className="icon" />, "Profile")}

          <li onClick={handleLogout}>
            <div className="menu-title logout">
              <ExitToAppIcon className="icon" />
              <span>Logout</span>
            </div>
          </li>

        </ul>
      </div>
    </div>
  );
};

export default Sidebar;
